import { CitiesShow, PaginationParams } from '../../../../types';
import { DefineRequest } from '../../types';
import { core } from '../../apis';
import { buildPaginationParams, unknownBy } from '../../helpers';

interface OptionsByUnscoped extends PaginationParams {
  by: 'unscoped';
}

export type GetCities = DefineRequest<OptionsByUnscoped, CitiesShow[]> & {
  optionsByUnscoped: OptionsByUnscoped;
};

export const getCities: GetCities['request'] = (options) => {
  const path = buildPath(options);
  return core
    .get<{ cities: GetCities['response'] }>({ accessToken: true }, path, {
      queryParams: buildPaginationParams(options),
    })
    .then((response) => response.cities);
};

const buildPath = (options: GetCities['options']) => {
  switch (options.by) {
    case 'unscoped': {
      return '/cities';
    }

    default: {
      throw unknownBy(options.by);
    }
  }
};
